module.exports = __webpack_public_path__ + "static/images/spike-btn-bg.cf08a77.png";